import React, { useEffect, useState } from 'react';
import { accessService } from '../../../services/central-api/access';
import { translate } from '../../../services/translate';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../../FormDropDownPicker';
import FilterRadioList, { FilterListItem } from './FilterRadioList';

type Props = {
    actingBodyId?: number;
    label: string;
} & ({
    form?: undefined;
    fieldName?: undefined;
    customValidations?: undefined;
    pattern?: undefined;
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function DispatchGenericUserList({ value, setValue, actingBodyId, label, form, fieldName }: Props) {
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getUsers(actingBodyId?: number) {
        try {
            setIsLoading(true);
            const users = await accessService.getAccessAllUsers({ actingBodyId });
            setItems(users.map((user) => ({ value: user.id, label: user.name })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getUsers(actingBodyId);
    }, [actingBodyId]);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate(label)}
            items={items}
            multiple={false}
            fieldName={fieldName}
            form={form}
            zIndex={1}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return <FilterRadioList items={items} value={value} setValue={setValue} clearValue={0} isLoading={isLoading} />;
    }

    return null;
}

export default DispatchGenericUserList;
